import React, { useState } from "react";
import HistorialRival from "./HistorialRival";
import PartidosClub from "../PartidosClub";
import SelectorRival from "./SelectorRival";
import * as Funciones from "../../funciones/FuncionesHistoriales";
import styles from "./RivalesClub.module.css";

const RivalesClub = (props) => {
  const club = props.club;
  const [rival, setRival] = useState(Funciones.ArmarRival(null,null));
  const [filtro, setFiltro] = useState(null);

  const onRivalElegido = (tipoElegido, rivalElegido) => {
    if (tipoElegido && rivalElegido) {
      setRival(Funciones.ArmarRival(tipoElegido, rivalElegido));
    } else {
      setRival(Funciones.ArmarRival(null,null))
    }
  }

  const onFiltroElegido = (filtro) => {
    setFiltro(filtro);
  };

  return (
    <div className={`${styles.columnas}`}>
      <div className={`${styles.columnaSelector}`}>
        <SelectorRival club={club} onRivalElegido={onRivalElegido} />
      </div>
      {rival && rival.objeto && (
        <React.Fragment>
          <div className={`${styles.columnaPartidos}`}>
            <PartidosClub club={club} rival={rival} onFiltroElegido={onFiltroElegido} />
          </div>
          <div className={`${styles.columnaHistorial}`}>
            <HistorialRival club={club} rival={rival} filtro={filtro} />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default RivalesClub;
